const PREFIX = 'order-wizard-draft-v1:'
const MAX_AGE_MS = 24 * 60 * 60 * 1000

export const orderWizardDraftKey = (orderId) => `${PREFIX}${orderId || 'new'}`

export function readOrderWizardDraft(key) {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    const draft = JSON.parse(raw)
    if (!draft?.formData || !draft.savedAt || Date.now() - draft.savedAt > MAX_AGE_MS) {
      sessionStorage.removeItem(key)
      return null
    }
    return draft
  } catch {
    return null
  }
}

export function saveOrderWizardDraft(key, draft) {
  try {
    sessionStorage.setItem(key, JSON.stringify({ ...draft, savedAt: Date.now() }))
  } catch {
    // La navigazione fra gli step resta utilizzabile anche senza storage.
  }
}

export function clearOrderWizardDraft(key) {
  try {
    sessionStorage.removeItem(key)
  } catch {
    // Nessuna bozza da rimuovere se lo storage non è disponibile.
  }
}

export function clearAllOrderWizardDrafts() {
  try {
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith(PREFIX)) sessionStorage.removeItem(key)
    }
  } catch {
    // Il logout non deve fallire se lo storage è disabilitato.
  }
}
